import { createJourneysOnSearch } from '@state/builders/journeys/create-journeys-on-search'
import { createBooking } from '@state/builders/bookings/create-booking'

export const createBookingOnSearch = (outwardJourneys, inwardJourneys) => {
  createBooking({ data: { status: 'unconfirmed' } }).then(({ bookings }) => {
    const { id: bookingId } = bookings[0]

    createJourneysOnSearch(outwardJourneys, inwardJourneys, bookingId)
  })
}
